/**
 * Format price in Indian Rupees
 * @param {number|string} price - The price to format
 * @param {boolean} showSymbol - Whether to show the ₹ symbol (default: true)
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, showSymbol = true) => {
  if (!price || isNaN(price)) {
    return showSymbol ? '₹0.00' : '0.00';
  }
  
  const numPrice = parseFloat(price);
  const formatted = numPrice.toFixed(2);
  
  return showSymbol ? `₹${formatted}` : formatted;
};

/**
 * Format price with Indian number system (lakhs, crores)
 * @param {number|string} price - The price to format
 * @param {boolean} showSymbol - Whether to show the ₹ symbol (default: true)
 * @returns {string} Formatted price string
 */
export const formatPriceIndian = (price, showSymbol = true) => {
  if (!price || isNaN(price)) {
    return showSymbol ? '₹0' : '0';
  }
  
  const numPrice = parseFloat(price);
  
  if (numPrice >= 10000000) {
    // Crores
    const crores = (numPrice / 10000000).toFixed(2);
    return showSymbol ? `₹${crores} Cr` : `${crores} Cr`;
  } else if (numPrice >= 100000) {
    // Lakhs
    const lakhs = (numPrice / 100000).toFixed(2);
    return showSymbol ? `₹${lakhs} L` : `${lakhs} L`;
  } else if (numPrice >= 1000) {
    // Thousands
    const thousands = (numPrice / 1000).toFixed(1);
    return showSymbol ? `₹${thousands}K` : `${thousands}K`;
  } else {
    // Regular formatting
    return formatPrice(price, showSymbol);
  }
};

/**
 * Get currency symbol
 * @returns {string} Indian Rupee symbol
 */
export const getCurrencySymbol = () => '₹';

/**
 * Get currency name
 * @returns {string} Currency name
 */
export const getCurrencyName = () => 'INR';
